module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("fsnJp"))).then(() => parcelRequire('dJXJK'));